export class DeleteProfilePicture {
    static readonly type = '[User] DeleteProfilePicture';

    constructor(public payload: { id: string }) {}
}
